import React from 'react'

import Layout from '../layouts/layout'
import SEO from '../components/seo'
import TitleHeader from '../components/titleheader'
import SecondaryNav from '../components/secondarynav'
import MBBoardOfDirectors from '../components/mbboardofdirectors.js'

import headerimage from '../assets/images/whoweare/Corprate_WhoWeAre_BoardofDirectors-A_03.gif'
import mbheaderimage from '../assets/images/whoweare/Corprate_WhoWeAre_BoardofDirectors-MB-A.gif'
import { trackPageData, getPageDetails } from '../analytics'
class BoardOfDirectors extends React.PureComponent {
  constructor(props) {
    super(props)

    let dataManager = {
      pageDetails: {},
    }
    if (typeof window !== `undefined`) {
      if (window.dataManager) {
        dataManager = window.dataManager
      }
    }
    dataManager.pageDetails = getPageDetails()
  }

  componentDidMount() {
    trackPageData()
  }

  render() {
    return (
      <Layout>
        <SEO
          title="Board of Directors | The Children's Place Corporate Website"
          description="Learn more about The Children's Place Board of Directors on The Children's Place Corporate Website."
        />

        {/* Page Title & Header Image */}
        <div class="row mb-3">
          <div class="col-12">
            <TitleHeader
              image={headerimage}
              mbheaderimage={mbheaderimage}
              title="WHO WE ARE"
            />
          </div>
        </div>
        {/* End Page Title & Header Image */}

        <SecondaryNav
          active="Board of Directors"
          name1="About Us"
          link1="/about-us"
          name2="Senior Leadership"
          link2="/senior-leadership"
          name3="Board of Directors"
          link3="/board-of-directors"
          name4="International Franchises"
          link4="/international-franchises"
        />

        <div class="firstgroup d-md-block" id="seniorleadershipcolapsegroup">
          {/* START Content for text Section1 */}
          <div class="row mb-3 option-list">
            <div class="col-lg-12 col-md-12 col-sm-12 blue_line">
              <h5
                class="pl-1 pr-1"
                style={{
                  display: `inline`,
                }}
              >
                TURKI SALEH A. ALRAJHI
              </h5>{' '}
              <span class="the_line"> | </span>
              <p
                class="pl-1 pr-1"
                style={{
                  display: `inline`,
                }}
              >
                Executive Chairman of the Board; Human Capital & Compensation Committee (Chair); Corporate Responsibility, Sustainability & Governance Committee (Chair)
              </p>
              {/* content */}
              <div class="bod-live-text">
              Mr. AlRajhi serves as Executive Chairman of the Board of the Company and Chair of the Human Capital & Compensation Committee and Corporate Responsibility, Sustainability & Governance Committee. He is also Chairman and Chief Executive Officer of Mithaq Holding Company and Managing Director of Mithaq Capital SPC. In these roles, he is responsible for developing and executing overall strategy, including capital allocation decisions and the selection and compensation of senior executives. Mr. AlRajhi holds a Bachelor of Finance and Banking from Dar Al Uloom University in the Kingdom of Saudi Arabia and completed the Value Investing Program at Columbia Business School in the United States of America. He aspires to master Chapters 8 and 20 of Prof. Benjamin Graham’s The Intelligent Investor.
              </div>
              {/* end content       */}
            </div>

            <div class="col-lg-12 col-md-12 col-sm-12 blue_line">
              <h5
                class="pl-1 pr-1"
                style={{
                  display: `inline`,
                }}
              >
                MUHAMMAD ASIF SEEMAB
              </h5>{' '}
              <span class="the_line"> | </span>
              <p
                class="pl-1 pr-1"
                style={{
                  display: `inline`,
                }}
              >
                Vice Chairman of the Board; President and Interim Chief Executive Officer
              </p>
              {/* content */}
              <div class="bod-live-text">
              Mr. Seemab serves as Vice Chairman of the Board and President and Interim Chief Executive Officer of the Company. He also serves as Managing Director of Mithaq Holding Company and Mithaq Capital SPC, where he is responsible for executing and managing the companies’ investments, including public equity, private equity, real estate, and income-producing assets in local and international markets. Mr. Seemab holds a Bachelor of Commerce from Hailey College of Commerce at the University of the Punjab and is a Chartered Accountant and an associate member of the Institute of Chartered Accountants of Pakistan.
              </div>
              {/* end content       */}
            </div>

            <div class="col-lg-12 col-md-12 col-sm-12 blue_line">
              <h5
                class="pl-1 pr-1"
                style={{
                  display: `inline`,
                }}
              >
                HUSSAN ARSHAD
              </h5>{' '}
              <span class="the_line"> | </span>
              <p
                class="pl-1 pr-1"
                style={{
                  display: `inline`,
                }}
              >
                Independent Director; Audit Committee (Chair); Corporate Responsibility, Sustainability & Governance Committee; Human Capital &amp; Compensation Committee
              </p>
              {/* content */}
              <div class="bod-live-text">
              Mr. Arshad serves as Independent Director and Chair of the Audit Committee of the Board of the Company. Prior to that, he held positions focusing on financial reporting, audit, governance, risk management and internal controls in various organizations, including Ernst &amp; Young, and Bell Canada Enterprise. Mr. Arshad is a member of the Chartered Professional Accounts (CPA) of Canada, The Institute of Chartered Accountants in England and Wales (ICAEW), The Institute of Chartered Accountants of Pakistan (ICAP), and The Institute of Internal Auditors (IIA) in the United States of America.
              </div>
              {/* end content*/}
            </div>

            {/* <div class="col-lg-12 col-md-12 col-sm-12 blue_line">
              <h5
                class="pl-1 pr-1"
                style={{
                  display: `inline`,
                }}
              >
                DOUGLAS EDWARDS
              </h5>
              <span class="the_line"> | </span>
              <p
                class="pl-1 pr-1"
                style={{
                  display: `inline`,
                }}
              >
                Independent Director; Corporate Responsibility, Sustainability &amp; Governance Committee (Chair); Audit Committee
              </p>
              
              <div class="bod-live-text">
              Mr. Edwards serves as an Independent Director and Chair of the Corporate Responsibility, Sustainability &amp; Governance Committee of the Board of the Company.  He served as the Executive Vice President and Interim General Counsel of Wells Fargo & Company, where he was responsible for the Global Commercial and Securities Division. In 2005, he was recognized as North Carolina's “Best Corporate Lawyer” in its annual Legal Elite selections and was named a North Carolina Super Lawyer in 2007, 2008, and 2009. Mr. Edwards holds a Bachelor of Arts from the University of Virginia, a Master of Arts in History from the University of Kentucky, and a Juris Doctorate of Law, cum laude, from the University of Buffalo in the United States of America.
              </div>
              
            </div> */}

            <div class="col-lg-12 col-md-12 col-sm-12 blue_line">
              <h5
                class="pl-1 pr-1"
                style={{
                  display: `inline`,
                }}
              >
                KIM ROY
              </h5>{' '}
              <span class="the_line"> | </span>
              <p
                class="pl-1 pr-1"
                style={{
                  display: `inline`,
                }}
              >
                Director
              </p>
              
              <div class="bod-live-text">
              Ms. Roy serves as an Independent Director of the Company and brings extensive leadership experience across multi-billion-dollar brand portfolios. Over the course of her career, she has held roles of increasing responsibility at leading retail organizations, including Ralph Lauren Corporation, where she most recently served as Group President, North America. Prior to that, Ms. Roy served as President of Ann Taylor, Group President at Liz Claiborne, Inc., and Senior Vice President, General Merchandise Manager at Associated Merchandising Corporation. Ms. Roy has also served on the Boards of Directors of Chico’s FAS, Inc. and Weight Watchers International, Inc. She is an advisor and former director of Catholic Guardian Services and a graduate of Skidmore College, where she serves as a long-standing Board Trustee.
              </div>
             
            </div> 
            <div class="col-lg-12 col-md-12 col-sm-12 blue_line">
              <h5
                class="pl-1 pr-1"
                style={{
                  display: `inline`,
                }}
              >
                RHYS SUMMERTON
              </h5>{' '}
              <span class="the_line"> | </span>
              <p
                class="pl-1 pr-1"
                style={{
                  display: `inline`,
                }}
              >
                Independent Director; Audit Committee, Human Capital & Compensation Committee
              </p>
              {/* content */}
              <div class="bod-live-text">
              Mr. Summerton serves as an Independent Director of the Company. He is the founder and investor at Milkwood Capital, a long-term, value-oriented, global investment company based in the UK. Since establishing the fund in 2014, he has successfully driven value realization across a range of investments through disciplined capital allocation and strategic decision-making. Before founding Milkwood, Mr. Summerton was Managing Director and Global Head of Emerging Market Equity Research at Citigroup, leading the firm’s top-ranked research franchise. A Chartered Accountant, he began his career with Ernst & Young. Mr. Summerton serves on the boards of various listed and unlisted companies, mostly where Milkwood Capital has influence.
              </div>
              {/* end content*/}
            </div>
          </div>
          {/* END Content for text Section1 */}

          {/* START Content for text Section2 */}
          <div class="row mb-3 option-list">
            <div class="col-lg-12 col-md-12 col-sm-12 ">
              <h5
                class="pl-1 pr-1"
                style={{
                  display: `inline`,
                }}
              >
                MUHAMMAD UMAIR
              </h5>{' '}
              <span class="the_line"> | </span>{' '}
              <p
                class="pl-1 pr-1"
                style={{
                  display: `inline`,
                }}
              >
                Director; Chief Strategy Officer
              </p>
              {/* content */}
              <div class="bod-live-text">
              Mr. Umair serves as Chief Strategy Officer and a Director of the Company. Previously, Mr. Umair served as President and Chief Executive Officer of the Company. Prior to joining The Children’s Place, Mr. Umair served as Senior Advisor at Origin Funding Partners, Head of Advisory at Armacom, and Senior Auditor at Ernst & Young. He is a Chartered Accountant and an associate member of the Institute of Chartered Accountants of Pakistan and the Institute of Chartered Accountants in England and Wales. Mr. Umair brings more than 19 years of financial and commercial experience spanning investment management, corporate advisory, operational and financial due diligence, audit, and business transformation.
              </div>
              {/* end content       */}
            </div>
          </div>
          <br />
          <br />
          <br />
          <br />
        </div>
      </Layout>
    )
  }
}

export default BoardOfDirectors
